var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c878e;\n        stroke: #7c878e;\n        stroke-miterlimit: 10;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.25,91.12h0l-.03-.03-.38-.42c2.37-5.01,2.65-9.03.84-11.95-2.61-4.19-8.54-4.46-9.48-4.45v-.02s-3.59.42-3.59.42v-5.28h-9.78v8.83l-28.49,19.36-3.75-9.92h-8.84v15.41H13v27.54h117.51l5.5-3.21v-21.16l23.74-15.8c2.49-1.44,4.28-.01,4.37.04l16.28,18.52,6.61-6.02-10.75-11.84Zm-10.48-2.31c-.13-.11-3.18-2.75-7.27-.38l-24.85,16.54v21.07l-3.78,2.21H15.36v-22.82h99.75v-15.41h4.86l4.24,11.19,32-21.74v-7.72h5.06v5.57l5.9-.69c.56.01,5.56.17,7.52,3.34,1.44,2.31,1,5.8-1.3,10.37l-.36.72,1.49,1.64h0s9.17,10.1,9.17,10.1l-3.1,2.82-14.8-16.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.99,114.1v7.18h42.44l-7.33-7.18H20.99Zm2.36,4.83v-2.47h31.8l2.52,2.47H23.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.06,121.28h42.44v-7.18h-35.12l-7.33,7.18Zm40.08-4.83v2.47h-34.32l2.52-2.47h31.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSander);
export default __webpack_public_path__ + "static/media/Sander.f039bfd050a9876270808dba1e604290.svg";
export { ForwardRef as ReactComponent };